const buyNowFeedBack = [
    {
      pageImg: "/Images/buyNow/buy_now_thank_you_sign_pop_up.png",
      pageAlt: "Ziggy cannot wait to start learning with you",
    },
  ];
  
  export default buyNowFeedBack;